module.exports = __webpack_public_path__ + "img/logo.e78adeb9.png";